// extracted by mini-css-extract-plugin
export default {"statusSelect":"style_statusSelect__MjZHD","statusSelectNonActive":"style_statusSelectNonActive__vkSLN","statusSelectActive":"style_statusSelectActive__y1hSw"};